import { render, staticRenderFns } from "./receiveList.vue?vue&type=template&id=57e66365&"
import script from "./receiveList.vue?vue&type=script&lang=js&"
export * from "./receiveList.vue?vue&type=script&lang=js&"
import style0 from "./receiveList.vue?vue&type=style&index=0&id=57e66365&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports